import React from 'react';
import PropTypes from 'prop-types';
import ShareAndFavourite from '../../TinyComponents/ShareAndFavourite';
import { LocalizationContext } from '../../../hoc/Localization';
import RegisterButton from '../RegisterButton';
import styles from './styles.less';

const RegisterList = ({
  course,
  schedules,
  canRegister,
  setRegister,
  join,
  selectedSchedule,
  setSelectedSchedule,
  domain,
  favouriteUrl,
  handleFavouriteClick,
  locale,
  school,
  lastRequestId,
}) => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <div className={styles.registerListContainer}>
      <div className={styles.imageWrapper}>
        <div className={styles.imageContainer}>
          <img src={course.image} alt="courseImage" />
        </div>
        <div className={styles.infoContainer}>
          <p className={styles.titleCategory}>{course.category[`title_${locale}`]}</p>
          <h2>{course.title}</h2>
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <div className={styles.shareAndFavorite}>
          <p className={styles.shareAndFavText}>{t('share.fav.text')}</p>
          <ShareAndFavourite
            course={course}
            domain={domain}
            favouriteUrl={favouriteUrl}
            handleFavouriteClick={handleFavouriteClick}
            locale={locale}
            school={school}
            size="large"
          />
        </div>
        <div className={styles.registerButton}>
          <RegisterButton
            canRegister={canRegister}
            selectedSchedule={selectedSchedule}
            setSelectedSchedule={setSelectedSchedule}
            course={course}
            schedules={schedules}
            setRegister={setRegister}
            join={join}
            lastRequestId={lastRequestId}
          />
        </div>
      </div>
    </div>
  );
};

RegisterList.propTypes = {
  course: PropTypes.object,
  schedules: PropTypes.array,
  canRegister: PropTypes.bool.isRequired,
  setRegister: PropTypes.func.isRequired,
  join: PropTypes.bool.isRequired,
  setSelectedSchedule: PropTypes.func,
  selectedSchedule: PropTypes.object,
  domain: PropTypes.string,
  favouriteUrl: PropTypes.string.isRequired,
  handleFavouriteClick: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  school: PropTypes.object.isRequired,
  lastRequestId: PropTypes.string,
};
RegisterList.defaultProps = {
  domain: '',
  course: {},
  schedules: [],
  selectedSchedule: null,
  setSelectedSchedule: () => {},
  lastRequestId: '',
};

export default RegisterList;
